import firebase from "firebase";
import { getCookie, removeAllCookies, setCookie } from "../utils/cookies";
import { axiosClient } from "./client";
import { checkRefreshTokenWithServer } from "./accountApp/authService";

const AUTH_ENDPOINT = `${process.env.REACT_APP_API_PRESTO_EXPRESS_ACCOUNTS}/account/add`;
const API_FIREBASE_AUTH_REFRESH_TOKEN = `https://securetoken.googleapis.com/v1/token?key=${process.env.REACT_APP_FIREBASE_AUTH_API_KEY}`;

export const authenticateTokenWithServer = (data) => {
  return axiosClient({
    url: AUTH_ENDPOINT,
    method: "POST",
    data,
  });
};

export const refreshAccessToken = async (refreshToken) => {
  try {
    const {
      data: { id_token, refresh_token },
    } = await axiosClient({
      url: API_FIREBASE_AUTH_REFRESH_TOKEN,
      method: "POST",
      data: {
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      },
    });
    const firebaseUser = getCookie("firebaseUser");
    await verifyAuthTokenWithServer(id_token, firebaseUser);
    return { id_token, refresh_token };
  } catch (error) {
    return { id_token: "", refresh_token: "" };
  }
};

export const verifyAuthTokenWithServer = async (idToken, firebaseUser) => {
  const { uid, displayName, photoURL, email, emailVerified } = firebaseUser;
  const data = {
    extId: uid,
    name: displayName,
    email: email,
    isActive: true,
    isEmailVerified: emailVerified,
    issuer: "firebase",
    profilePic: photoURL,
    isAuthenticated: true,
  };
  if (!uid) return;
  try {
    await authenticateTokenWithServer(data);
  } catch (e) {}
  setCookie("firebaseUser", data, {
    domain: process.env.REACT_APP_ALLOWED_DOMAIN,
  });
  setCookie("idToken", idToken, {
    domain: process.env.REACT_APP_ALLOWED_DOMAIN,
  });
};

const handleRefreshToken = async (idToken) => {
  try {
    const res = await checkRefreshTokenWithServer({ idToken }); // <-- wrap in object if expected
    return res?.status === 200; // explicitly check status if axios config allows
  } catch (error) {
    console.error("Token validation failed", error?.response?.status || error);
    return false;
  }
};

const handleLogout = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      // Sign-out successful.
      removeAllCookies();
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
    })
    .catch((error) => {
      console.error("error", error);
    });
};

// export const verifyAuthTokenWithServer = async (
//   idToken,
//   firebaseUser,
// ) => {
//   const { uid, displayName, photoURL, email, emailVerified } = firebaseUser;
//   const data = {
//     extId: uid,
//     name: displayName,
//     email: email,
//     isActive: true,
//     isEmailVerified: emailVerified,
//     issuer: "firebase",
//     profilePic: photoURL,
//     isAuthenticated: true,
//   };
//   if (!uid) return;
//   await authenticateTokenWithServer(data);

//   const isVerified = await handleRefreshToken(idToken);
//   if (isVerified) {
//     setCookie("firebaseUser", data, {
//       domain: process.env.REACT_APP_ALLOWED_DOMAIN,
//     });
//     setCookie("idToken", idToken, {
//       domain: process.env.REACT_APP_ALLOWED_DOMAIN,
//     });
//   } else {
//     handleLogout();
//   }
// };
